var map = {
	"./Opslog1.jpeg": 9271,
	"./Opslog10.jpeg": 9388,
	"./Opslog11.jpeg": 3561,
	"./Opslog2.jpeg": 1647,
	"./Opslog3.jpeg": 1627,
	"./Opslog4.jpeg": 2697,
	"./Opslog5.jpeg": 2420,
	"./Opslog6.jpeg": 1216,
	"./Opslog7.jpeg": 6644,
	"./Opslog8.jpeg": 3588,
	"./Opslog9.jpeg": 7431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2020;